import { render, staticRenderFns } from "./IbSelectEntry.vue?vue&type=template&id=6b48e184&scoped=true"
import script from "./IbSelectEntry.vue?vue&type=script&lang=js"
export * from "./IbSelectEntry.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b48e184",
  null
  
)

export default component.exports